import { VariantProps, cva } from 'class-variance-authority';
import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import styles from './Skelton.module.scss';

const skeltonVariants = cva(['bg-black/10 dark:bg-white/10', 'block max-w-full'], {
    variants: {
        variant: {
            text: [styles['skelton-text']],
            rectangular: ['w-full rounded-[10px]'],
            circular: ['rounded-full'],
        },
        animation: {
            pulse: [styles['skelton-pulse-animate']],
            wave: [styles['skelton-wave-animate']],
        },
    },
    defaultVariants: {
        animation: 'pulse',
        variant: 'text',
    },
});

interface SkeltonProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>,
        VariantProps<typeof skeltonVariants> {
    width?: string | number;
    height?: string | number;
    ref?: ForwardedRef<HTMLSpanElement>;
}

const Skelton = forwardRef<HTMLSpanElement, SkeltonProps>((props, ref) => {
    const { variant, animation, width, height, className, style, ...rest } = props;

    return (
        <span
            {...rest}
            ref={ref}
            className={twMerge(skeltonVariants({ variant, animation, className }))}
            style={{ width, height, ...style }}
        />
    );
});

export default Skelton;
